import OTPForm from './OTPForm';
import useOTP from './useOTP';

const OTPAuth = () => {
  const {isLoading, otp, handleOTPChange, handleResendOTP, countdown} =
    useOTP();
  return (
    <OTPForm
      isLoading={isLoading}
      otp={otp}
      handleOTPChange={handleOTPChange}
      handleResendOTP={handleResendOTP}
      countdown={countdown}
    />
  );
};

export default OTPAuth;
